import FormComponent from "./Components/FormComponent";
import React, { createRef } from "react";
/**
 * Class to defined the form used to confirm a user's information once
 * they initiate the request a callback flow. Should have a name field
 * which may or may not be editable, a radio group for the phonenumber,
 * and a dropdown for the reason for the call.
 */
export default class AdvancedFormMessage extends FormComponent {
    constructor(props) {
        super(props);

        this.selectRef = createRef();
        this.selectionErrorRef = createRef();
    }

    /**
     * Iterates through the dropdown options in the field and creates
     * the dropdown HTML block.
     */
    createDropdownOptions() {
        const dropdownOptionsBlock = [];
        dropdownOptionsBlock.push(<option value=''>Please select</option>);
        for (const element of this.props.payload.listItems[2].dropdownOptions) {
            dropdownOptionsBlock.push(<option key={element} value={element.value}>{element.label}</option>);
        }
        return dropdownOptionsBlock;
    }

    /**
     * Genreates the name field and whether it should be should as an editable text
     * input or if it should render out as a standard <div> with a hidden input value.
     * @param {{type: String, title: String, keyBackToKore: String, editable: Boolean, label: String}} input
     */
    generateNameField(input) {
        if (input.editable) {
            return  <div>
                        <label htmlFor={`nameInput-${this.formId}`}>{input.title}</label>
                        <input type='text' id={`nameInput-${this.formId}`} name={input.keyBackToKore} value={input.label} required />
                    </div>
        }
        else {
            return  <div>
                        <div className='label'>{input.title}</div>
                        <div>{input.label}</div>
                        <input type='hidden' id={`nameInput-${this.formId}`} name={input.keyBackToKore} value={input.label} required />
                    </div>
        }
    }

    /**
     * Renders the @type {AdvancedFormMessage} message template. If the template has been
     * interacted with in the current chat session OR is returned in the chat history,
     * so not render out the form portion.
     */
    render() {
        if (this.props.message.isChatHistory || this.state.formSubmitted) {
            return  <div className={this.generateSenderClassName('advanced-form')}>
                        {this.generateSenderMessage()}
                        <div className='advanced-form__text message-text'>
                            <div className='advanced-form__title'>
                                {this.props.payload.title}
                            </div>
                            <div className='advanced-form__description'>
                                {this.props.payload.description}
                            </div>
                        </div>
                    </div>
        }
        return (
            <div className={this.generateSenderClassName('advanced-form')}>
                {this.generateSenderMessage()}
                <div className='advanced-form__text message-text'>
                    <div className='advanced-form__title'>
                        {this.props.payload.title}
                    </div>
                    <div className='advanced-form__description'>
                        {this.props.payload.description}
                    </div>
                    <form className='advanced-form__form form' onSubmit={this.submitForm}>
                        <div className='form__input-wrapper'>
                            {this.generateNameField(this.props.payload.listItems[0])}
                        </div>
                        <div className='form__input-wrapper' role='radiogroup' aria-labelledby={`phoneNumberGroup-${this.formId}`}>
                            <div className='label' id={`phoneNumberGroup-${this.formId}`}>
                                {this.props.payload.listItems[1].title}
                            </div>
                            {this.props.payload.listItems[1].options.map((radio, index) => {
                                return  <div className='radio__wrapper' key={radio}>
                                            <input type='radio' name={this.props.payload.listItems[1].keyBackToKore} value={radio.value} id={`phoneNumber-${this.formId}-${index}`} className='radio__input' required/>
                                            <label htmlFor={`phoneNumber-${this.formId}-${index}`}>{radio.label}</label>
                                        </div>
                            })}
                        </div>
                        <div className='form__input-wrapper'>
                            <label htmlFor={`reason-${this.formId}`}>{this.props.payload.listItems[2].title}</label>
                            <div className='dropdown__input-wrapper'>
                                <select name={this.props.payload.listItems[2].keyBackToKore} id={`reason-${this.formId}`} className='dropdown__input' required>
                                    {this.createDropdownOptions()}
                                </select>
                            </div>
                        </div>
                        <button className='button--black' type='submit' title='Submit your information.'>
                            {this.props.payload.button.label}
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}